import classNames from 'classnames'
import { BoxProps, Flex, Text } from '@homebotapp/hb-react-component-catalog'

import Status from '../Status'

import styles from './AnimatedCheckListItem.module.scss'

export interface AnimatedCheckListItemProps extends BoxProps {
  isCompleted: boolean
  // Children is just a string for now. We can adjust if/when
  // we need to add more complex content.
  children: string
}

export const AnimatedCheckListItem = ({ isCompleted, children, ...flexProps }: AnimatedCheckListItemProps) => {
  return (
    <Flex as='li' alignItems='center' {...flexProps}>
      <Status complete={isCompleted} className={classNames(isCompleted && styles.completed)} />
      <Text as='span' color={isCompleted ? 'neutral.400' : 'neutral.900'} transition='all 0.35s ease-out' ml='4'>
        {children}
      </Text>
    </Flex>
  )
}
